/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Brand } from './Brand';
import {
    instanceOfBrand,
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';

/**
 * @type CreateOtherQaEquipmentDtoBrand1
 * 
 * @export
 */
export type CreateOtherQaEquipmentDtoBrand1 = Brand;


export function CreateOtherQaEquipmentDtoBrand1FromJSON(json: any): CreateOtherQaEquipmentDtoBrand1 {
    return CreateOtherQaEquipmentDtoBrand1FromJSONTyped(json, false);
}

export function CreateOtherQaEquipmentDtoBrand1FromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherQaEquipmentDtoBrand1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...BrandFromJSONTyped(json, true) };
    return  BrandFromJSONTyped(json, true);
}

export function CreateOtherQaEquipmentDtoBrand1ToJSON(value?: CreateOtherQaEquipmentDtoBrand1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfBrand(value)) {
        return BrandToJSON(value as Brand);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOtherQaEquipmentDtoBrand1 interface.
 */
export function instanceOfCreateOtherQaEquipmentDtoBrand1(value: any): value is CreateOtherQaEquipmentDtoBrand1 {
    if (instanceOfBrand(value)) return true;
    return false;
}

